import React from 'react';
import Footer from './Footer';
import '../css/revisionAutoridades.scss';
import Breadcrumbs from './Breadcrumbs';
import puertoPichi from '../assets/images/desembarque/autobus.jpg';
import puertoTopo from '../assets/images/desembarque/autobus.jpg';
import puertoMaza from '../assets/images/desembarque/autobus.jpg';

export default function RevisionAutoridades() {
  return (
    <>
      <section className="revisionAutoridades">
        {/* HERO */}
        <div className='info-documentacion-hero revision-autoridades-hero'>
            <div className='overlay'></div>

            <div className='container'>
                <div className='hero-content'>

                    <div style={{ marginTop: '4rem' }} style={{ color: '#fff' }}>
                        <Breadcrumbs />
                    </div>

                    <h1>Trámites y Aduana</h1>

                    <p>
                        Guía completa de procesos de desembarque y requisitos legales para tu travesía en el Mar de Cortés.
                    </p>

                </div>
            </div>
        </div>
        <div className="container">
          <div className="puertos-autoridades-content">
          
            {/* PICHILINGUE */}
            <div className="puertoCard">
              <div className="puertoImagen">
                <img src={puertoPichi} alt="Puerto de Pichilingue" />
                <div className="ubicacionBadge">
                  La Paz, B.C.S.
                </div>
              </div>

              <div className="puertoContenido">
                <h2>Puerto de Pichilingue, La Paz.</h2>

                <div className="puertoGrid">
                  <div className="instruccionesGenerales">
                    <h3>Instrucciones Generales</h3>

                    <ul>
                      <li>
                        Para el desembarque, nuestro personal indicará los turnos
                        por número de cubierta.
                      </li>

                      <li>
                        Sigue siempre las instrucciones del personal de seguridad.
                      </li>
                    </ul>
                  </div>

                  <div className="procesoVehiculos">
                    <h3>Proceso de Vehículos</h3>

                    <div className="pasosTimeline">
                      <div className="pasoProceso">
                        <span>1</span>
                        <p>Revisión de Marina</p>
                      </div>

                      <div className="pasoProceso">
                        <span>2</span>
                        <p>Pago de ATP (Línea o Efectivo)</p>
                      </div>

                      <div className="pasoProceso">
                        <span>3</span>
                        <p>Fumigación</p>
                      </div>

                      <div className="pasoProceso">
                        <span>4</span>
                        <p>Revisión Militar</p>
                      </div>

                      <div className="pasoProceso">
                        <span>5</span>
                        <p>Fumigación Final</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* TOPOLOBAMPO */}
            <div className="puertoCard puertoCardReverse">
              <div className="puertoImagen">
                <img src={puertoTopo} alt="Puerto de Topolobampo" />
                <div className="ubicacionBadge">
                  Topolobampo, SIN.
                </div>
              </div>

              <div className="puertoContenido">
                <h2>Puerto de Topolobampo, Sinaloa.</h2>

                <div className="infoBoxes">
                  <div className="infoBox">
                    <p>
                      Para desembarcar, sigue las instrucciones de nuestro
                      personal, quienes indicarán los turnos por número de
                      cubierta.
                    </p>
                  </div>

                  <div className="infoBox">
                    <p>
                      Al descender del buque sigue la señalética. Personal
                      portuario podría solicitarte documentación de tu vehículo
                      o personal.
                    </p>
                  </div>
                </div>

                <div className="notaImportante">
                  <strong>Nota:</strong> Los procesos del puerto son ajenos a
                  Baja Ferries.
                </div>
              </div>
            </div>

            {/* MAZATLÁN */}
            <div className="puertoCard">
              <div className="puertoImagen">
                <img src={puertoMaza} alt="Puerto de Mazatlán" />
                <div className="ubicacionBadge">
                  Mazatlán, SIN.
                </div>
              </div>

              <div className="puertoContenido">
                <h2>Puerto de Mazatlán, Zona de Desembarque.</h2>

                <div className="pasosGrid">

                  <div className="pasoCard">
                    <div className="pasoNumero">
                      Paso 1
                    </div>

                    <p>
                      Desembarque por orden de cubierta
                    </p>
                  </div>

                  <div className="pasoCard">
                    <div className="pasoNumero">
                      Paso 2
                    </div>

                    <p>
                      Seguir indicaciones de seguridad
                    </p>
                  </div>

                  <div className="pasoCard">
                    <div className="pasoNumero">
                      Paso 3
                    </div>

                    <p>
                      Atención a señalética y documentos
                    </p>
                  </div>

                </div>

                <div className="notaImportante">
                  <strong>Nota:</strong> Los procesos del puerto son ajenos a
                  Baja Ferries.
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="soporteSection">
        <div className="soporteContainer">

          <h2>
            ¿Tienes dudas sobre los trámites?
          </h2>

          <p>
            Nuestro equipo de atención a clientes está disponible
            para apoyarte en cada paso de tu viaje.
          </p>

          <div className="soporteBotones">
            <button className="btnPrimario">
              Contactar Soporte
            </button>

            <button className="btnSecundario">
              Preguntas Frecuentes
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}